<template>
  <v-dialog
    v-model="show"
    max-width="400"
    @input="v => v || onCloseDialog()"
  >
    <v-card>
      <v-card-title :class="colorTheme">
        <span class="white--text">
          Please confirm stage transition.
        </span>
      </v-card-title>
      <v-alert
        v-if="error"
        type="error"
        :value="true"
        class="mt-2"
      >
        {{ error }}
      </v-alert>
      <v-progress-linear
        v-if="loading"
        :indeterminate="true"
        class="ma-0"
      />
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-container
          v-if="stageTransitionRequiresPrompt"
          fluid
        >
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
            >
              <custom-field
                v-if="isStageTransitionToClosed"
                :type="'date'"
                :color-theme="colorTheme"
                :value="paidAt"
                label="Closed At"
                :on-change="e => onDatePickerChange(e, 'paidAt')"
              />
              <custom-field
                v-if="isStageTransitionToDefaulted"
                :type="'date'"
                :color-theme="colorTheme"
                :value="defaultedAt"
                label="Defaulted At"
                :on-change="e => onDatePickerChange(e, 'defaultedAt')"
              />
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-spacer />

          <v-btn
            flat="flat"
            :disabled="processing"
            @click="onCloseDialog()"
          >
            Close
          </v-btn>

          <v-btn
            :color="colorTheme"
            flat="flat"
            :disabled="processing"
            @click="submit()"
          >
            confirm
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import Stages from '../../enum/financialProducts/Stages';
import CustomField from '@/components/financialProducts/shared/CustomField';

export default {
  name: 'StageTransitionConfirmationDialog',
  components: {
    CustomField,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    processing: {
      type: Boolean,
      default: false,
    },
    submitAction: {
      type: Function,
      default: () => ({}),
    },
    cancelAction: {
      type: Function,
      default: () => ({}),
    },
    error: {
      type: String,
      default: '',
    },
    colorTheme: {
      type: String,
      default: 'blue',
    },
    financialProduct: {
      type: Object,
      required: true,
    },
    transitionToStage: {
      type: String,
      required: true,
    },
    onCustomFieldChange: {
      type: Function,
      required: true,
    },
    getCustomFieldValue: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      valid: true,
      show: this.dialog,
      paidAt: this.getCustomFieldValue('paid_at'),
      defaultedAt: this.financialProduct.defaulted_at,
      loading: false,
      requiredRule: [
        v => !!v || 'field is required',
      ],
    };
  },
  computed: {
    isStageTransitionToClosed() {
      return this.transitionToStage === Stages.CLOSED;
    },
    isStageTransitionToDefaulted() {
      return this.transitionToStage === Stages.DEFAULTED;
    },
    stageTransitionRequiresPrompt() {
      return (this.transitionToStage === Stages.CLOSED || this.transitionToStage === Stages.DEFAULTED);
    },
  },
  watch: {
    dialog(val) {
      this.show = val;
    },
  },
  methods: {
    onDatePickerChange(date, field) {
      this[field] = date.value;
    },
    async submit() {
      this.loading = true;
      if (this.paidAt) {
        this.onCustomFieldChange('date', 'paidAt', this.paidAt);
      }
      if (this.defaultedAt) {
        this.financialProduct.defaulted_at = this.defaultedAt;
      }
      await this.submitAction(this.transitionToStage);
      this.loading = false;
      this.onCloseDialog();
    },
    onCloseDialog() {
      this.cancelAction();
      this.setToDefault();
    },
    setToDefault() {
      this.paidAt = '';
      this.defaultedAt = '';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/financialProducts/StageTransitionConfirmationDialog.vue